import { render } from "./LoginFooter.vue?vue&type=template&id=399deada"
import script from "./LoginFooter.vue?vue&type=script&lang=js"
export * from "./LoginFooter.vue?vue&type=script&lang=js"

import "./LoginFooter.vue?vue&type=style&index=0&id=399deada&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__